'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'

interface TitleBlockData {
  subtitle?: string
  title?: string
  desk_max_width?: string | number
}

interface TitleBlockProps {
  data: TitleBlockData
}

const TitleBlock: React.FC<TitleBlockProps> = ({ data }) => {
  const processedTitle = data.title ? processStrapiTextTags(data.title) : ''

  if (!data.subtitle && !data.title) {
    return null
  }

  const titleStyle = data.desk_max_width 
    ? { maxWidth: `${data.desk_max_width}px` } 
    : undefined

  return (
    <section className={styles.titleBlock}>
      {data.subtitle && (
        <div className={styles.subtitle}>{data.subtitle}</div>
      )}
      {processedTitle && (
        <h2 
          className={styles.title}
          style={titleStyle}
          dangerouslySetInnerHTML={{ __html: processedTitle }}
        />
      )}
    </section>
  )
}

TitleBlock.displayName = 'TitleBlock'

export default TitleBlock

